import type { ISaksmelding } from './ISaksmelding';
import { VedleggSak } from './VedleggSak';

export class Saksmelding implements ISaksmelding {
    public get id() {
        return this._id;
    }

    public get created() {
        return this._created;
    }

    public get melding() {
        return this._melding;
    }

    public get opprettetAv() {
        return this._opprettetAv;
    }

    public get sakId() {
        return this._sakId;
    }

    public get vedleggSakList() {
        return this._vedleggSakList;
    }

    public static empty() {
        return Saksmelding.parseObject({
            melding: '',
            sakId: '',
            vedleggSakList: [],
        });
    }

    public static parseObject(obj: ISaksmelding): Saksmelding {
        try {
            return new Saksmelding(obj);
        } catch (e) {
            throw new Error('Not able to parse object');
        }
    }

    private readonly _melding: ISaksmelding['melding'];
    private readonly _sakId: ISaksmelding['sakId'];

    private readonly _id?: ISaksmelding['id'];
    private readonly _created?: ISaksmelding['created'];
    private readonly _opprettetAv?: ISaksmelding['opprettetAv'];
    private readonly _vedleggSakList: ISaksmelding['vedleggSakList'] = [];

    constructor(obj: ISaksmelding) {
        this._id = obj.id;
        this._created = obj.created;
        this._melding = obj.melding;
        this._opprettetAv = obj.opprettetAv;
        this._sakId = obj.sakId;

        this._vedleggSakList =
            obj.vedleggSakList.map((vedlegg) =>
                VedleggSak.parseObject(vedlegg),
            ) || [];
    }

    public toSaksmelding = () => {
        const { melding, sakId, vedleggSakList } = this;
        return {
            melding,
            sakId,
            vedleggSakList: vedleggSakList.map((vedlegg) =>
                vedlegg.toVedleggSak(),
            ),
        };
    };
}
